import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  exportExcelReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'
// import * as Constants from '@/constant'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

const SearchInfoBean = {
  compId: '',
  projId: '',
  entityId: '',
  costColId: '',
  levelOneId: '',
  productId: '',
  // jobContent: '',
  spec: '',
  unit: '',
  // brand: '',
  // deliveryNo: '',
  // stockInNo: '',
  END_SEARCH_INFO_BEAN: null
}

const InfoBean = {
  levelOneId: '',
  pdTransDt: '',
  settleDt: '', // 冗余字段的名称(非数据库字段)
  settleStartDt: '',
  settleEndDt: '',
  // deliveryNo: '',
  // stockInNo: '',
  productId: '',
  // jobContent: '',
  spec: '',
  unit: '',
  leaseDt: '',
  inNum: 0,
  outNum: 0,
  leaseDuration: 0,
  priceWithTax: 0, // 冗余字段的名称(非数据库字段)
  vatRate: 0,
  priceWithoutTax: 0,
  withTaxAmt: 0,
  taxAmt: 0,
  withoutTaxAmt: 0,
  deductionAmt: 0,
  // brand: '',
  inquiryDt: '',
  remarks: '',
  crtBy: '',
  crtOn: null,
  updBy: '',
  updOn: null
}

const state = {
  searchInfo: { ...SearchInfoBean },
  searchedForm: { ...SearchInfoBean },
  list: [],
  info: {
    ...InfoBean
  },
  listPagging: Utils.getDefaultListPagging(),
  pdSummaryList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  insertRspProjSettleLease({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.INSERT_RSP_PROJ_SETTLE_LEASE, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  updateRspProjSettleLease({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_LEASE, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  removeRspProjSettleLease({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_SETTLE_LEASE + `/${key.compId}/${key.projId}/${key.entityId}/${key.transId}/${key.pdTransId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleLease({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_LEASE + `/${key.compId}/${key.projId}/${key.entityId}/${key.transId}/${key.pdTransId}`)
        .then(res => {
          state.info = res.data
          state.info.pdTransDt = new Date(res.data.pdTransDt)
          state.info.settleStartDt = new Date(res.data.settleStartDt)
          state.info.settleEndDt = new Date(res.data.settleEndDt)
          state.info.leaseDt = new Date(res.data.leaseDt)
          state.info.inquiryDt = new Date(res.data.inquiryDt)
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleLeaseListByTransId({
    commit,
    state,
    rootState
  }, { compId, projId, entityId, transId }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_LEASE_LIST_BY_TRANS_ID + `/${compId}/${projId}/${entityId}/${transId}`)
        .then(res => {
          state.list = res.data
          // Utils.resetListPagging(state.listPagging, res)
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleLeaseList({
    commit,
    state,
    rootState
  }, { currentPage, pageSize }) {
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.FIND_RSP_PROJ_SETTLE_LEASE_PAGE_LIST, {
        data: {
          currentPage,
          pageSize,
          queryVO: {
            compId: state.searchedForm.compId,
            projId: state.searchedForm.projId,
            entityId: state.searchedForm.entityId,
            costColId: state.searchedForm.costColId,
            levelOneId: state.searchedForm.levelOneId,
            productId: state.searchedForm.productId,
            // jobContent: state.searchedForm.jobContent,
            spec: state.searchedForm.spec,
            unit: state.searchedForm.unit
            // band: state.searchedForm.band
            // deliveryNo: state.searchedForm.deliveryNo,
            // stockInNo: state.searchedForm.stockInNo
          }
        }
      }).then(res => {
        state.list = res.data
        Utils.resetListPagging(state.listPagging, res)
        StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
      }).catch(err => {
        reject(err)
      })
    })
  },
  async downloadRspProjSettleLeaseList({
    commit,
    state,
    rootState
  }) {
    let data = {
      compId: state.searchedForm.compId,
      projId: state.searchedForm.projId,
      entityId: state.searchedForm.entityId,
      costColId: state.searchedForm.costColId,
      levelOneId: state.searchedForm.levelOneId,
      productId: state.searchedForm.productId,
      // jobContent: state.searchedForm.jobContent,
      spec: state.searchedForm.spec,
      unit: state.searchedForm.unit
      // band: state.searchedForm.band
      // deliveryNo: state.searchedForm.deliveryNo,
      // stockInNo: state.searchedForm.stockInNo
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_SETTLE_LEASE_LIST, {data})
    return response
  },
  findRspProjSettleLeaseSummaryByEntityId({
    commit,
    state,
    rootState
  }, { compId, projId, entityId }) {
    state.pdSummaryList = []
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_LEASE_SUMMARY_BY_ENTITY_ID + `/${compId}/${projId}/${entityId}`)
        .then(res => {
          state.pdSummaryList = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  resetSearchInfo(state) {
    state.searchInfo = { ...SearchInfoBean }
  },
  resetInfo(state) {
    state.info = { ...InfoBean }
  },
  addListItem(state, { index }) {
    state.list.splice(index, 0, { ...InfoBean })
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/pdtrans/rspProjSettleLeaseManage.js